import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../assets/css/welcome.scss';
import LogoBk from '../../assets/images/logo-accelerate-bk.svg';
import Img3 from '../../assets/images/img-accelerate-screenshot.png';

const Teaser2 = () => {
  return (
    <>
      <Container fluid className="fullscreen">
        <header>
          <a href="/" rel="noopener">
            <img src={LogoBk} className="logo-bk" alt="Accelerate" />
          </a>
        </header>
        <Row style={{ marginTop: '80px' }}>
          <Col lg={6} className="bgGray d-flex align-items-center">
            <div>
              <h1 className="mb-4">All New Accelerate Platform</h1>
              <h3 className="mb-5">
                10x faster creation of intelligent workflows
                <br />
                10x less IT resources to get machine learning live
                <br />
                10x more chance of successful business outcomes
              </h3>
              <a href="/register" className="btn btn-primary btn-lg px-5" rel="noopener">
                Start for free
              </a>
            </div>
          </Col>
          <Col lg={6} className="bgGray">
            <img src={Img3} alt="Accelerate Platform" width="100%" className="mt-4" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { Teaser2 };
